/* 日刻首发 */
import React, { useEffect, useState, useRef, Component } from 'react';
import { useRouteMatch, useHistory, useLocation, useParams, Route } from "react-router-dom";
import {
    LaunchApp, copy, detector, ua,
    isAndroid, isIos, supportLink, inWeixin, inWeibo
} from 'web-launch-app';
import moment from 'moment';
import { Toast } from "antd-mobile";
import '../css/RikeFirst.scss';
import RikeService from '../services/Rike';
import { getParameter } from "../utils/func";

const RikeFirst = ({ props }) => {
    let match = useRouteMatch();
    let location = useLocation();
    let history = useHistory();
    let params = useParams();
    const APPID = 'wx754e1b2a81936e91' // appid
    const [user, setUser] = useState({});
    const [orderData, setOrderData] = useState({});
    const [timer, setTimer] = useState(null);
    const [isActivity, setIsActivity] = useState(true);
    // useEffect(() => {
    //     if (moment('2020-11-26').isBefore(new Date(), 'date')) {
    //         setIsActivity(false);
    //         Toast.info('该活动已结束');
    //     }
    // }, []);
    // const openTodoApp = () => {
    //     // 唤起（微博出引导提示，ios微信去appstore，android微信去应用宝，同时指定超时处理及下载包）
    //     if (isIos) {
    //         window.location.replace("https://a.app.qq.com/o/simple.jsp?pkgname=com.kairos.todolist");
    //     } else if (isAndroid) {
    //         if (inWeixin) {
    //             // window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.kairos.todolist";//这里写APP链接，安卓同事会给。找到就打开APP，找不到就跳到下面链接
    //             window.location.replace("https://a.app.qq.com/o/simple.jsp?pkgname=com.kairos.todolist");//这里写APP链接，安卓同事会给。找到就打开APP，找不到就跳到下面链接
    //         } else {
    //             window.location.href = "myapp://jp.app/openwith?title=" + course.title + "&subTitle=" + course.subtitle + "&courseId=" + course.id;
    //             window.setTimeout(function () {
    //                 window.location.href = "http://download.kairusi.com/1TodoS/1TodoS.apk";//没有本地APP的，就打开输入的网址。    去下载APP的网址
    //                 //微信不让打开外部APP，必须跳到类如应用宝（QQ所属产品）的市场，应用宝会判断本机有没这个APP，有就可以直接打开。
    //             }, 2000);
    //         }
    //     } else {
    //         window.location.href = "https://www.kairusi.com/html/product.html";
    //     }
    // };
    useEffect(() => {
        document.body.style = "background: #8C0807;";
    }, [])
    const browser = {
        versions: function () {
            var u = navigator.userAgent, app = navigator.appVersion;
            return {
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
                iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                souyue: u.indexOf('souyue') > -1,
                superapp: u.indexOf('superapp') > -1,
                weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
                qq: u.match(/\sQQ/i) == " qq", //是否QQ
                Safari: u.indexOf('Safari') > -1
            };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };
    const openTodoApp = () => {
        if (browser.versions.weixin) {
            if (browser.versions.ios) {
                window.location.href = "https://www.kairusi.com/thinkdiary";
            } else if (browser.versions.android) {
                window.location.href = "https://www.kairusi.com/thinkdiary";
            }
            // window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.kairos.todolist";
        } else {
            if (browser.versions.android) {
                window.location.href = "rikeapp://rike.app/open";
                window.setTimeout(function () {
                    window.location.href = "https://www.kairusi.com/thinkdiary";
                }, 2000);
            } else if (browser.versions.ios) {
                window.location.href = "https://www.kairusi.com/thinkdiary";
            }
        }
    };
    useEffect(() => {
        const token = getParameter("token", location.search);
        const code = getParameter("code");
        const remark = getParameter("remark", location.search);
        if (code && inWeixin) {
            isRegister();
        }
    }, []);
    // useEffect(() => {
    //     window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${encodeURIComponent("http://todo.kairusi.cn" + "/web/rike/mobile/#" + location.pathname + location.search)}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
    // }, []);
    useEffect(() => {
        return () => {
            clearInterval(timer);
            // localStorage.removeItem("orderWx");
        };
    })
    // 微信授权
    const toWxpayAuth = () => {
        // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${encodeURIComponent("http://127.0.0.1:3000" + "/#" + location.pathname + location.search)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${encodeURIComponent("http://todo.kairusi.cn" + "/web/rike/mobile/#" + location.pathname + location.search)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    };
    // 是否注册过
    const isRegister = () => {
        const code = getParameter("code");
        RikeService.checkRegister({ code }).then(res => {
            // if (res.data.u_id === "0") {
            //     openTodoApp();
            // } else {
            //     setUser(res.data);
            //     createOrder(res.data);
            // }
            setUser(res.data);
            createOrder(res.data);
        }).catch(error => error.message && Toast.info(error.message))
    };
    // 创建订单
    const createOrder = (userObject) => {
        const token = getParameter("token", location.search);
        RikeService.createOrder({ type: '5', unionid: userObject.wx_unionid, u_id: userObject.u_id, openid: userObject.openid, share_token: token }).then(res => {
            setOrderData(res.data);
            localStorage.setItem("orderWx", JSON.stringify(res.data));
            toPay(res.data);
        }).catch(error => {
            error.message && Toast.info(error.message, 3);
            setTimeout(() => {
                window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/rike/first?token=" + token);
            }, 3000);
        })
    };
    // 查询订单
    const getOrderStatus = () => {
        const token = getParameter("token", location.search);
        RikeService.getOrderStatus({ order_sn: JSON.parse(localStorage.getItem("orderWx")).order_sn }).then(payInfo => {
            if (payInfo.data.status === 1) {
                clearInterval(timer);
                localStorage.removeItem("orderWx");
                Toast.info('购买成功', 2);
                setTimeout(() => {
                    window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/rike/first?token=" + token);
                }, 2000);
            }
        }).catch(error => {
            error.message && Toast.info(error.message, 2);
            setTimeout(() => {
                window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/rike/first?token=" + token);
            }, 2000);
        })
    };
    const onBridgeReady = (wxpayData) => {
        WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
            "appId": wxpayData.appid,     //公众号名称，由商户传入     
            "timeStamp": wxpayData.timestamp,         //时间戳，自1970年以来的秒数     
            "nonceStr": wxpayData.nonce_str, //随机串     
            // "package": "prepay_id=" + wxpayData.prepay_id,
            "package": wxpayData.package,
            "signType": "MD5",         //微信签名方式：     
            "paySign": wxpayData.sign //微信签名 
        },
            function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    if (localStorage.getItem("orderWx") && JSON.parse(localStorage.getItem("orderWx")).order_sn) {
                        setTimer(setInterval(() => {
                            getOrderStatus();
                        }, 1000))
                    }
                } else {
                    const token = getParameter("token", location.search);
                    localStorage.removeItem("orderWx");
                    window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/rike/first?token=" + token);
                }
            });
    };
    // 立即支付
    const toPay = (wxpayData) => {
        if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady(wxpayData), false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady(wxpayData));
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady(wxpayData));
            }
        } else {
            onBridgeReady(wxpayData);
        }
    };

    const guize = ['① 每个账号限购1个终身VIP',
        '② 终身VIP购买后自动生效，既无法退订/退款',
        '③ 终身VIP享有未来持续更新的新功能',
        '④ 终身VIP限时推出，绝无仅有的时机',
        '⑤ 活动最终解释权归凯如斯所有'
    ]

    return (
        <div className="rike-first-box">
            <img src={require('../image/rike/rike-first-bk.png')} alt="" className="rike-first-bk"/>
            <div className="rike-first-bottom">
                <img src={require('../image/rike/rike-first-button.png')} className="rike-first-button"onClick={toWxpayAuth}/>
                <img src={require('../image/rike/rike-first-text.png')} className="rike-first-text"/>
                <div className="rule-box">
                    <p className="rule-title">活动说明:</p>
                    {
                        guize.map((el, i) => {
                            return <p key={i} className="rule-item">{el}</p>
                        })
                    }
                </div>
            </div>
        </div>
    )
};

export default RikeFirst;